const LEAD = 'LEAD';
const HOLD = 'HOLD';
const BOOKED = 'BOOKED';
const COMPLETED = 'COMPLETED'; // DEPRECATED - Should not be adding stages for the CANCELLED project status
const CANCELLED = 'CANCELLED';

const STATUSES = [LEAD, HOLD, BOOKED] as const;

const StageProjectStatus = {
  LEAD,
  BOOKED,
  CANCELLED,
  STATUSES,

  // DEPRECATED
  COMPLETED,
};

export default StageProjectStatus;
